import type { QueryClientConfig } from "@tanstack/react-query"
import { CustomerApiError } from "./api.js"

export const customerQueryCacheMs = 30_000
export const customerQueryGarbageCollectionMs = 5 * 60_000
export const customerQueryRetryDelayMs = 250

export function shouldRetryCustomerQuery(failureCount: number, error: unknown) {
  if (failureCount >= 1) {
    return false
  }
  if (error instanceof DOMException && error.name === "AbortError") {
    return false
  }
  return !(error instanceof CustomerApiError) || error.status >= 500
}

export const customerQueryClientConfig: QueryClientConfig = {
  defaultOptions: {
    mutations: {
      retry: false,
    },
    queries: {
      gcTime: customerQueryGarbageCollectionMs,
      refetchOnReconnect: true,
      refetchOnWindowFocus: false,
      retry: shouldRetryCustomerQuery,
      retryDelay: customerQueryRetryDelayMs,
      staleTime: customerQueryCacheMs,
    },
  },
}
